
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.7098 11.29L12.7098 2.29C12.3198 1.9 11.6898 1.9 11.2998 2.29L2.29982 11.29C1.90982 11.68 1.90982 12.31 2.29982 12.7L11.2998 21.7C11.6898 22.09 12.3198 22.09 12.7098 21.7L21.7098 12.7C22.0998 12.32 22.0998 11.69 21.7098 11.29ZM13.9998 14.5V12H9.99982V14C9.99982 14.55 9.54982 15 8.99982 15C8.44982 15 7.99982 14.55 7.99982 14V11C7.99982 10.45 8.44982 10 8.99982 10H13.9998V7.5L17.1498 10.65C17.3498 10.85 17.3498 11.16 17.1498 11.36L13.9998 14.5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-directions`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDirections

    ```js
    <b-new-b-icon-directions />
    ```
</docs>


